export class OrbiConstants {
}
OrbiConstants.NumSleepSecondsForRequestThrottling = 1;
OrbiConstants.AuditWorkbookNameContinuous = "AuditWorkbookContinuous";
OrbiConstants.AuditWorkbookNameDefault = "KoaSOC22021Q2";
